<template>
  <div   ref="btnDropdownRef" v-on:mouseover="onOver($event)" v-on:mouseleave="onLeave">
    <a class="text-gray-600 block" href="javascript:void(0)">
      <div class="items-center flex profile">
        <span class="w-10 h-10 text-sm text-white bg-gray-300 inline-flex items-center justify-center rounded-full">
          <img
            alt="..."
            class="w-full rounded-full align-middle border-none shadow-lg"
            :src="image"
          />
        </span>
        <span  class="cursor-pointer text-blue-600 ml-2 title">Welcome {{user.fullName}} 
          <span class="details">{{user.type}} </span>
        </span>
      </div>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50  py-2 list-none text-left rounded shadow-lg dropdown-menu-shipp"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
    <div  class="drop-item user-details">
       <a  href="javaScript:;">
         <div  class="media"><div class="avatar">
           <img  :src="image" alt="user avatar" class="align-self-start mr-3">
          </div>
          <div  class="media-body">
              <h6  class="mt-2 user-title">{{user.fullName}}</h6>
              <p  class="user-subtitle">{{user.email}}</p>
          </div>
          </div>
        </a>
    </div>
    <div class="h-0 my-2 border border-solid border-gray-200"></div>
       <router-link to="/profil"  class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800" >
            <span class="flex items-center">
                    <i class="material-icons">person_outline</i>
                <span class="mx-4 font-medium">Account</span>
            </span>
        </router-link>
     <!-- <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
        My products
      </a>
      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
         My orders
      </a>-->
      <div class="h-0 my-2 border border-solid border-gray-200" />
      <a
        href="javascript:void(0);"  @click="logout"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
          <span class="flex items-center">
                    <i class="material-icons">input</i>
                <span class="mx-4 font-medium">Logout</span>
            </span>
      </a>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

import image from "@/assets/shipsen-man.jpg";

export default {
  data() {
    return { 
      dropdownPopoverShow: false,
      image: 'https://img.icons8.com/fluency/96/user-male-circle--v1.png',
    };
  },
  props:{
    user:{type:Object}
  },
  methods: {
     logout() {
      this.$jwtService.destroyToken();
      location.href = "/";
      //this.$router.push("home");
    },
    onOver: function (event) {
      event.preventDefault();
      if (!this.dropdownPopoverShow) {
         this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    onLeave() {
        this.dropdownPopoverShow = false;
    }
  },
};
</script>
